var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"relative"}},[_c('div',{ref:"radarchart",staticStyle:{"width":"100%","height":"100%"}}),_c('img',{staticStyle:{"position":"absolute","right":"20px","top":"50%","transform":"translateY(-50%)"},attrs:{"src":require("../../../assets/image/legend.png"),"alt":"legend"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }